import { useQuery } from '@tanstack/react-query'
import { userNotificationsControllerGetUnreadCount } from 'api.gen'
import type { UnreadCountResponse } from '../types'

const POLLING_INTERVAL = 30_000

export const useUnreadCount = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['user-notifications-unread-count'],
    queryFn: async () => {
      const response = await userNotificationsControllerGetUnreadCount()
      return response.data as unknown as UnreadCountResponse
    },
    refetchInterval: POLLING_INTERVAL
  })

  return {
    count: data?.count ?? 0,
    isLoading
  }
}
